<template>
  <div>
    <vs-popup :title="$t('CreateGrouping')" :active.sync="showModal">
      <form v-if="show">
        <div>
          <vs-input
            class="inputx mb-4 mt-1"
            v-model="model.name"
            name="groupName"
            :label="$t('GroupName')"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('groupName')">{{
            errors.first("groupName")
          }}</span>
        </div>
        <div class="mb-4">
          <label class="vs-select--label">{{ $t("PhoneNumberLeader") }}</label>
          <treeselect
            name="user"
            :multiple="false"
            :placeholder="$t('SearchUser')"
            :async="true"
            :load-options="loadUserOptions"
            ref="user"
            @select="onUserSelected"
          />
          <span class="text-danger text-sm" v-show="errors.has('leaderName')">{{
            errors.first("leaderName")
          }}</span>
        </div>
        <div>
          <vs-input
            class="inputx mb-4 mt-1"
            v-model="model.zone"
            name="zone"
            :label="$t('Zone')"
          />
          <span class="text-danger text-sm" v-show="errors.has('zone')">{{
            errors.first("zone")
          }}</span>
        </div>

        <vs-button
          type="filled"
          class="float-right mb-4 mt-4"
          @click.prevent="submitForm"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

const dict = {
  custom: {
    groupName: {
      required: "لطفا نام گروه را وارد نمایید.",
    },
    leaderName: {
      required: "لطفا نام مسوول را وارد نمایید.",
    },
    zone: {
      required: "لطفا zone را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "warehouseManagement_Warehouses_ModifyPopup",
  components: {
    Treeselect,
    "v-select": vSelect,
  },
  props: {
    show: { default: false },
  },
  data() {
    return {
      model: {},
      countTagId: "",
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
    ...mapGetters({
      allProvinces: "country/provinceList",
      allCities: "country/cityList",
      locationInfo: "country/details",
    }),
  },
  methods: {
    ...mapActions({
      searchCustomerByPhone: "identityAccess/searchCustomerByPhone",
      createGroup: "warehouseHandling/createGroup",
    }),
    loadUserOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.searchCustomerByPhone(searchQuery).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.id,
                  userName: element.userName,
                  label: element.userName,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onUserSelected(data) {
      this.model.leaderName = data.userName;
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.model.countingTagId = this.countTagId;
          this.createGroup(this.model).then(() => {
            this.model = {};
            this.$emit("finish");
          });
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.countTagId = this.$route.params.id;
      }
    },
  },
};
</script>
